
/*globals STATIC_URL*/
import React from 'react';
import {
  Row,
  Columns,
} from 'views/Grid';
import root from 'window-or-global';

const Footer = () => {
  const { is_anchor_text } = root.INITIAL_STATE || {};
  const footerText = is_anchor_text ? 'Better than a Payment Gateway -' : 'Powered by';
  return (
    <footer>
      <Row className="collapse soft--ends">
        <Columns className="small-12 text-center">
          <a href="/?utm_source=widget&utm_campaign=offerfooter&utm_medium=poweredby" target="_blank">
            <span className="text-black">
              { footerText }
              &nbsp;
              <img
                style={{ height: 21 }}
                src={`${STATIC_URL}assets/images/logo.png`}
                alt="Payment Gateway provided by Instamojo" />
            </span>
          </a>
        </Columns>
      </Row>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/product/views/_layout/Footer.js